module.exports = __webpack_public_path__ + "fonts/Inter-Thin-slnt=0.35b7cf4c.ttf";